import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PinStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.47217 10C3.47217 5.66934 6.64573 1.25 11.9999 1.25C17.3542 1.25 20.5277 5.66934 20.5277 10C20.5277 12.0976 19.3391 14.3892 17.9805 16.3532C16.6001 18.3488 14.9448 20.1449 13.8248 21.2784C12.812 22.3035 11.1879 22.3035 10.175 21.2784C9.05511 20.1449 7.39976 18.3488 6.01937 16.3532C4.66084 14.3892 3.47217 12.0976 3.47217 10ZM11.9999 2.75C7.63194 2.75 4.97217 6.33066 4.97217 10C4.97217 11.6094 5.92112 13.5744 7.25299 15.4999C8.56301 17.3937 10.1509 19.1197 11.2421 20.2242C11.6677 20.6549 12.3322 20.6549 12.7578 20.2242C13.849 19.1197 15.4369 17.3937 16.7469 15.4999C18.0788 13.5744 19.0277 11.6094 19.0277 10C19.0277 6.33066 16.368 2.75 11.9999 2.75Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 8.30555C11.1869 8.30555 10.5278 8.96468 10.5278 9.77777C10.5278 10.5909 11.1869 11.25 12 11.25C12.8131 11.25 13.4722 10.5909 13.4722 9.77777C13.4722 8.96468 12.8131 8.30555 12 8.30555ZM9.02778 9.77777C9.02778 8.13626 10.3585 6.80555 12 6.80555C13.6415 6.80555 14.9722 8.13626 14.9722 9.77777C14.9722 11.4193 13.6415 12.75 12 12.75C10.3585 12.75 9.02778 11.4193 9.02778 9.77777Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PinStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PinStrokeIcon;
